// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"84634be5","674":"438801ea","875":"b37fad64"}[chunkId] + ".chunk.js";
};